import React, { useCallback, useEffect, useState } from 'react'
import useGetMoneyPoolManagement from './hooks/useGetMoneyPoolManagement'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Header from 'modules/fund/header'
import DotsLoading from 'components/loadings/dotsLoading'
import SubHeader from 'modules/fund/subHeader'
import useGetBulletins from './hooks/useGetBulletins'
import CustomCarousel, { AddBulletinTile } from 'modules/fund/carousel'
import CustomTabs from 'modules/fund/tabs'
import useGetUsers from 'modules/fund/tabs/hooks/useGetUsers'
import AddNewLoanModal from 'components/modals/addNewLoan'
import DownloadExcelModal from 'components/modals/downloadExcel'
import DownloadExcelEmailModal from 'components/modals/downloadExcelEmail'
import PayToOtherModal from 'components/modals/payToOther'

export default function Fund() {
    const [selectUser, setSelectUser] = useState<
        undefined | IMoneyPoolResults
    >()
    const [isOpenPayToOtherModal, setIsOpenPayToOtherModal] =
        useState<boolean>(false)
    const [isOpenNewLoan, setIsOpenNewLoan] = useState<boolean>(false)
    const [isOpenExcelModal, setIsOpenExcelModal] = useState<boolean>(false)
    const [isOpenExcelModalEmail, setIsOpenExcelModalEmail] =
        useState<boolean>(false)
    const [fullReportCount, setFullReportCount] = useState<number>(0)
    const [searchUser, setSearchUser] = useState<string>('')
    const [search, setSearch] = useState<string>(' ')

    const { id } = useParams()
    const navigate = useNavigate()
    const { moneyPoolManagement, isLoadingMoneypoolManagement } =
        useGetMoneyPoolManagement(id)
    const { bulletins, isLoadingBulletins } = useGetBulletins(id)
    const {
        data,
        isLoading,
        poolShipId,
        fetchNextPage,
        numberOfShares,
        refetch,
    } = useGetUsers(id, searchUser)
    const { state } = useLocation()
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])

    const isFuckingManager = () => {
        return (
            moneyPoolManagement?.poolship?.role === 'mgr' ||
            moneyPoolManagement?.poolship?.role === 'own'
        )
    }

    useEffect(() => {
        if (search === '') {
            setSearchUser('')
        }
    }, [search])

    return (
        <div className=" bg-white relative">
            {moneyPoolManagement && !isLoadingMoneypoolManagement ? (
                <>
                    <Header
                        exist={moneyPoolManagement.balance}
                        hamyanBalance={moneyPoolManagement.hamyan_balance}
                        bankBalance={moneyPoolManagement.bank_balance}
                        inprogress={moneyPoolManagement.inprogress_balance}
                        balance={moneyPoolManagement.balance}
                        showBalance={moneyPoolManagement.show_box_balance}
                        poolShipId={poolShipId}
                        role={moneyPoolManagement?.poolship?.role}
                        setIsOpenExcelModal={setIsOpenExcelModal}
                        isFuckingManager={isFuckingManager}
                        name={moneyPoolManagement.name}
                        servicePackage={moneyPoolManagement.service_package}
                        trustedState={moneyPoolManagement.trust_state}
                        hiddenFinanceDetail={
                            moneyPoolManagement.hidden_finance_detail
                        }
                    />
                    <SubHeader
                        capital={moneyPoolManagement.capital}
                        workingCapital={moneyPoolManagement.working_capital}
                        intervalPotency={moneyPoolManagement.interval_potency}
                        date={moneyPoolManagement.jalali_due_date}
                        intervalShareIncome={
                            moneyPoolManagement.interval_share_income
                        }
                        totalShares={moneyPoolManagement.total_shares}
                        shareValueAmount={
                            moneyPoolManagement.share_value_amount
                        }
                        cashinsAmount={moneyPoolManagement.cashins_amount}
                        cashoutAmounts={moneyPoolManagement.cashouts_amount}
                        createDate={moneyPoolManagement.jalali_created}
                        imageId={moneyPoolManagement.image_id}
                        avatar={moneyPoolManagement.custom_avatar}
                        name={moneyPoolManagement.name}
                        isFuckingManager={isFuckingManager}
                        showBalance={moneyPoolManagement.show_box_balance}
                        hiddenFinanceDetail={
                            moneyPoolManagement.hidden_finance_detail
                        }
                        remainingDays={
                            moneyPoolManagement.service_package_remaining_days
                        }
                    />
                    {!isLoadingBulletins && bulletins ? (
                        <>
                            {bulletins.length > 0 ? (
                                <div className="mx-2 mt-2">
                                    <CustomCarousel
                                        bulletins={bulletins}
                                        isFuckingManager={isFuckingManager}
                                    />
                                </div>
                            ) : (
                                isFuckingManager() && (
                                    <div
                                        className="mx-2 mt-2 cursor-pointer rounded-[16px] bg-[#F2F2F2]"
                                        onClick={() =>
                                            navigate('/fund/bulletin', {
                                                state: {
                                                    moneyPool: id,
                                                    bulletins,
                                                    isManager:
                                                        isFuckingManager(),
                                                },
                                            })
                                        }
                                    >
                                        <AddBulletinTile />
                                    </div>
                                )
                            )}
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                    {/* Action buttons — Android grids (rendered force-LTR there):
                        Manager (bottom_holder): row1 واریز وجه (right) / برداشت وجه (left),
                        row2 اعطای وام جدید (right) / وام‌های درخواستی (left).
                        Normal member (normal_bottom_holder): واریز وجه (right) / درخواست وام (left).
                        Each button 31dp tall, 4dp radius, 12px inter-gap,
                        16px total edge margin (10dp holder + 6dp button). */}
                    <div className="grid grid-cols-2 gap-x-3 gap-y-2 mx-4 mt-2 mb-[18px]">
                        {isFuckingManager() ? (
                            <>
                                {/* row 1: واریز وجه (right), برداشت وجه (left) */}
                                <button
                                    className="h-[31px] rounded-[4px] bg-green-1 px-0 text-center text-sm font-bold text-white active:scale-[0.98]"
                                    onClick={() =>
                                        navigate(`/loans/deposit/${id}`, {
                                            state: {
                                                id: id,
                                                poolShipId: poolShipId,
                                                name: moneyPoolManagement.name,
                                                moneyPoolId: id,
                                                shareValueAmount:
                                                    moneyPoolManagement.share_value_amount,
                                                numberOfShares: numberOfShares,
                                                role: moneyPoolManagement
                                                    ?.poolship?.role,
                                                trustState:
                                                    moneyPoolManagement?.trust_state,
                                            },
                                        })
                                    }
                                >
                                    واریز وجه
                                </button>
                                <button
                                    className="h-[31px] rounded-[4px] bg-green-1 px-0 text-center text-sm font-bold text-white active:scale-[0.98]"
                                    onClick={() =>
                                        navigate(
                                            `/loans/withDraw/${id}/${poolShipId}`,
                                            {
                                                state: {
                                                    exist: moneyPoolManagement.balance,
                                                    name: moneyPoolManagement.name,
                                                },
                                            }
                                        )
                                    }
                                >
                                    برداشت وجه
                                </button>
                                {/* row 2: اعطای وام جدید (right), وام‌های درخواستی (left) */}
                                <button
                                    className="h-[31px] rounded-[4px] bg-green-1 px-0 text-center text-sm font-bold text-white active:scale-[0.98]"
                                    onClick={() => setIsOpenNewLoan(true)}
                                >
                                    اعطای وام جدید
                                </button>
                                <button
                                    className="h-[31px] rounded-[4px] bg-green-1 px-0 text-center text-sm font-bold text-white active:scale-[0.98]"
                                    onClick={() =>
                                        navigate(
                                            `/loans/requested-loans/${id}`,
                                            {
                                                state: {
                                                    poolShipId: poolShipId,
                                                    name: moneyPoolManagement.name,
                                                    exist: moneyPoolManagement.balance,
                                                    isManager:
                                                        isFuckingManager(),
                                                },
                                            }
                                        )
                                    }
                                >
                                    وام‌های درخواستی
                                </button>
                            </>
                        ) : (
                            <>
                                {/* normal member: واریز وجه (right), درخواست وام (left) */}
                                <button
                                    className="h-[31px] rounded-[4px] bg-green-1 px-0 text-center text-sm font-bold text-white active:scale-[0.98]"
                                    onClick={() =>
                                        navigate(`/loans/deposit/${id}`, {
                                            state: {
                                                id: id,
                                                poolShipId: poolShipId,
                                                name: moneyPoolManagement.name,
                                                moneyPoolId: id,
                                                shareValueAmount:
                                                    moneyPoolManagement.share_value_amount,
                                                numberOfShares: numberOfShares,
                                                role: moneyPoolManagement
                                                    ?.poolship?.role,
                                                trustState:
                                                    moneyPoolManagement?.trust_state,
                                            },
                                        })
                                    }
                                >
                                    واریز وجه
                                </button>
                                <button
                                    className="h-[31px] rounded-[4px] bg-green-1 px-0 text-center text-sm font-bold text-white active:scale-[0.98]"
                                    onClick={() =>
                                        navigate(
                                            `/loans/requested-loans/${id}`,
                                            {
                                                state: {
                                                    poolShipId: poolShipId,
                                                    name: moneyPoolManagement.name,
                                                    exist: moneyPoolManagement.balance,
                                                    isManager:
                                                        isFuckingManager(),
                                                },
                                            }
                                        )
                                    }
                                >
                                    درخواست وام
                                </button>
                            </>
                        )}
                    </div>
                    {!isLoading && data ? (
                        <CustomTabs
                            data={data}
                            isLoading={isLoading}
                            onWatchEnd={onWatchEnd}
                            setIsOpenPayToOtherModal={setIsOpenPayToOtherModal}
                            setSelectUser={setSelectUser}
                            shareValueAmount={
                                moneyPoolManagement.share_value_amount
                            }
                            isManager={
                                moneyPoolManagement?.poolship?.role === 'mgr' ||
                                moneyPoolManagement?.poolship?.role === 'own'
                                    ? true
                                    : false
                            }
                            activeMemberCount={
                                moneyPoolManagement.active_members_count
                            }
                            transactionsCount={
                                moneyPoolManagement.num_cashins_cashouts
                            }
                            loansCount={moneyPoolManagement.loans_count}
                            setSearchUser={setSearchUser}
                            search={search}
                            setSearch={setSearch}
                            refetch={refetch}
                            hiddenLoans={moneyPoolManagement.hidden_loans}
                        />
                    ) : (
                        <DotsLoading />
                    )}
                </>
            ) : (
                <DotsLoading />
            )}
            <AddNewLoanModal
                show={isOpenNewLoan}
                onHide={() => setIsOpenNewLoan(false)}
                id={id}
                poolShipId={poolShipId}
                exist={moneyPoolManagement && moneyPoolManagement.balance}
                name={moneyPoolManagement && moneyPoolManagement.name}
            />
            <DownloadExcelModal
                show={isOpenExcelModal}
                onHide={() => setIsOpenExcelModal(false)}
                moneyPool={id}
                setIsOpenExcelModalEmail={setIsOpenExcelModalEmail}
                setFullReportCount={setFullReportCount}
            />
            <DownloadExcelEmailModal
                show={isOpenExcelModalEmail}
                onHide={() => setIsOpenExcelModalEmail(false)}
                moneyPool={id}
                fullReport={fullReportCount}
            />
            <PayToOtherModal
                show={isOpenPayToOtherModal}
                onHide={() => setIsOpenPayToOtherModal(false)}
                item={selectUser}
                name={moneyPoolManagement && moneyPoolManagement.name}
                isManager={
                    moneyPoolManagement?.poolship?.role === 'mgr' ||
                    moneyPoolManagement?.poolship?.role === 'own'
                        ? true
                        : false
                }
                trustState={moneyPoolManagement?.trust_state}
            />
        </div>
    )
}
